import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import AllUsers from './Components/AllUsers';
import Articles from './Components/Articles';
import ContactTable from './Components/ContactTable';
import PaymentHistoryTable from './Components/PaymentHistoryTable';
import Login from './Components/Login';
import ResetPassword from './Components/ResetPassword';
import Plan from './Components/Plan';
import News from './Components/News';
import Coupon from './Components/Coupon';
import { ToastContainer } from 'react-toastify';
import CouponUsage from './Components/CouponUsage';
import Volume from './Components/Volume';
import Issues from './Components/Issues';
import AboutPublication from './Components/AboutPublication';

const App = () => {
  const location = useLocation();

  // Correct login check based on stored user object
  const storedUser = JSON.parse(localStorage.getItem("isLoggedIn"));
  const isLoggedIn = storedUser && storedUser.email;

  return (
    <SidebarProvider>
      <div className="app-container">
        {/* Show sidebar if logged in */}
        {isLoggedIn && <Sidebar />}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />

            {/* Protected Routes */}
            <Route path="/" element={isLoggedIn ? <Articles /> : <Navigate to="/login" />} />
            <Route path="/all-users" element={isLoggedIn ? <AllUsers /> : <Navigate to="/login" />} />
            <Route path="/contact" element={isLoggedIn ? <ContactTable /> : <Navigate to="/login" />} />
            <Route path="/payment-history" element={isLoggedIn ? <PaymentHistoryTable /> : <Navigate to="/login" />} />
            <Route path="/plan" element={isLoggedIn ? <Plan /> : <Navigate to="/login" />} />
            <Route path="/volume" element={isLoggedIn ? <Volume /> : <Navigate to="/login" />} />
            <Route path="/issue" element={isLoggedIn ? <Issues /> : <Navigate to="/login" />} />
            <Route path="/news" element={isLoggedIn ? <News /> : <Navigate to="/login" />} />
            <Route path="/about-publication" element={isLoggedIn ? <AboutPublication /> : <Navigate to="/login" />} />
            <Route path="/coupon" element={isLoggedIn ? <Coupon /> : <Navigate to="/login" />} />
            <Route path="/couponusage" element={isLoggedIn ? <CouponUsage /> : <Navigate to="/login" />} />
            {/* Catch-all route */}
            <Route path="*" element={<Navigate to={isLoggedIn ? "/" : "/login"} />} />
          </Routes>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </SidebarProvider>
  );
};

export default App;
